import googleMapsLogo from '~/assets/images/google_maps.svg';
import questionProLogo from '~/assets/images/questionpro-black.svg';
import spotifyLogo from '~/assets/images/spotify.svg';
import vimeoLogo from '~/assets/images/vimeo.svg';
import youtubeLogo from '~/assets/images/youtube.svg';

import type { UsercentricsServiceKey } from './usercentricsServices';

type CookieConsentServiceConfig = {
    brandName: string;
    logoSrc: string;
    logoAlt: string;
};

export const cookieConsentServices = {
    google_maps: {
        brandName: 'Google Maps',
        logoSrc: googleMapsLogo,
        logoAlt: 'Google Maps logo'
    },
    spotify: {
        brandName: 'Spotify',
        logoSrc: spotifyLogo,
        logoAlt: 'Spotify logo'
    },
    youtube: {
        brandName: 'YouTube',
        logoSrc: youtubeLogo,
        logoAlt: 'YouTube logo'
    },
    question_pro: {
        brandName: 'QuestionPro',
        logoSrc: questionProLogo,
        logoAlt: 'QuestionPro logo'
    },
    vimeo: {
        brandName: 'Vimeo',
        logoSrc: vimeoLogo,
        logoAlt: 'Vimeo logo'
    }
} as const satisfies Partial<Record<UsercentricsServiceKey, CookieConsentServiceConfig>>;

export type CookieConsentServiceKey = keyof typeof cookieConsentServices;
